<template>
  <div class="wrap">
    <div class="banner" :style="{backgroundImage: 'url(' + imgUrl.banner + ')'}">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">病区护理工作中心与移动护理系统</p>
      </div>
    </div>
    <div class="content">
      <div class="en t2"></div>
      <div class="inner product">
        <h2>产品<em>介绍</em></h2>
        <div class="details">
          <div class="img">
            <img :src="imgUrl.img1"
                 alt="">
          </div>
          <div class="text bg">
            <p>病区护理工作中心以病区中央监护中心主电脑为核心,患者床旁执行终端、护士专属执行电脑、护士随身移动终端为辅助，实现对全病区医嘱执行、生命体征监控、输液监控、患者意外防控、护理执行自动跟催等全系列护理管理工作实现便捷化、数字化、AI智能化、 自动化。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content bg">
      <div class="en t3"></div>
      <div class="inner product">
        <h2><em>服务</em>与<em>功能</em></h2>
        <div class="p-list">
          <ul>
            <li class="p1">
              <em></em>
              <h3>医嘱执行系统</h3>
            </li>
            <li class="p2">
              <em></em>
              <h3>输液执行系统</h3>
            </li>
            <li class="p3">
              <em></em>
              <h3>处置执行系统</h3>
            </li>
            <li class="p4">
              <em></em>
              <h3>交接班工作跟进系统</h3>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getAliyunImg from '../../utils/aliyun'

export default {
  name: 'nurse',
  created () {
    this.imgUrl.banner = getAliyunImg.signatureUrl('ytwd/gw/emr-banner.png')
    this.imgUrl.img1 = getAliyunImg.signatureUrl('ytwd/gw/emr-text.png')
    this.imgUrl.bg1 = getAliyunImg.signatureUrl('ytwd/gw/emr-img1.png')
    this.imgUrl.bg2 = getAliyunImg.signatureUrl('ytwd/gw/emr-img2.png')
    this.imgUrl.bg3 = getAliyunImg.signatureUrl('ytwd/gw/emr-img3.png')
    this.imgUrl.bg4 = getAliyunImg.signatureUrl('ytwd/gw/emr-img4.png')
  },
  data () {
    return {
      imgUrl: {
        banner: '',
        img1: '',
        bg1: '',
        bg2: '',
        bg3: '',
        bg4: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./css/style.scss";
.banner {
  // background-image: url("../../assets/images/emr-banner.png");
  .icon {
    background-image: url("../../assets/images/s7.png");
  }
}
.content {
  .product .details {
    align-items: center;
    .text {
      padding: 75px 30px;
      display: flex;
      height: auto;
      // align-self: flex-start;
      &.bg {
        background-size: 210px 207px;
      }
    }
    .img {
      // height: 535px;
      background: none;
    }
  }
}
.p-list {
  margin: 80px 0 50px;
  ul {
    width: 1300px;
    height: 416px;
    li {
      width: 242px;
      height: 416px;
      border-radius: 10px;
      margin-right: 77px;
      background-repeat: no-repeat;
      background-position: -2px 0;
      box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.14);
      float: left;
      // overflow: hidden;
      em {
        background-repeat: no-repeat;
        background-position: top center;
        display: block;
        width: 100%;
        height: 102px;
        margin-top: 104px;
      }
      h3 {
        margin-top: 60px;
        color: #00dcd4;
        font-size: 24px;
        text-align: center;
      }
      &.p1 {
        background-image: url("../../assets/images/emr-img1.png");
        em {
          background-image: url("../../assets/images/emr-icon1.png");
        }
      }
      &.p2 {
        background-image: url("../../assets/images/emr-img2.png");
        em {
          background-image: url("../../assets/images/emr-icon2.png");
        }
      }
      &.p3 {
        background-image: url("../../assets/images/emr-img3.png");
        em {
          background-image: url("../../assets/images/emr-icon3.png");
        }
      }
      &.p4 {
        background-image: url("../../assets/images/emr-img4.png");
        em {
          background-image: url("../../assets/images/emr-icon4.png");
        }
      }
    }
  }
}
</style>
